import React from "react";
import { IconProps } from "./types";

interface MinusCollapseIconProps extends IconProps {
  fillColor?: string;
  strokeColor?: string;
  iconColor?: string;
}

const MinusCollapseIcon: React.FC<MinusCollapseIconProps> = ({
  width = 16,
  height = 16,
  className,
  fillColor = "white",
  strokeColor = "#015C9A",
  iconColor = "#015C9A",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M8 0.361328C12.2188 0.361328 15.6387 3.78116 15.6387 8C15.6387 12.2188 12.2188 15.6387 8 15.6387C3.78116 15.6387 0.361328 12.2188 0.361328 8C0.361328 3.78116 3.78116 0.361328 8 0.361328Z"
        fill={fillColor}
        stroke={strokeColor}
        strokeWidth="0.722222"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.43237 8.00068C5.43237 7.8234 5.57608 7.67969 5.75336 7.67969H10.2472C10.4245 7.67969 10.5682 7.8234 10.5682 8.00068C10.5682 8.17795 10.4245 8.32166 10.2472 8.32166H5.75336C5.57608 8.32166 5.43237 8.17795 5.43237 8.00068Z"
        fill={iconColor}
      />
    </svg>
  );
};

export default MinusCollapseIcon;
